import {local} from './local';
import {dev} from './dev';
import {stg} from './stg';
import {prd} from './prd';

export const env = {local, dev, stg, prd};
